module.exports = __webpack_public_path__ + "static/media/ss.6733ebaf.webp";